<template>
  <div class="org">
    <div class="org-head">
      <div class="org-head_root">
        <div class="org_root_icon"></div>
        组织机构列表
      </div>
      <div v-show="titleList.length > 1" class="org-head_title">
        <div
          :class="{
            org_title: true,
            org_title_checked: title.id === curOrg.id,
          }"
          v-for="(title, index) in titleList"
          :key="title.id"
          @click="handleTitleClick(title, index)"
        >
          <div v-if="index" class="org_title_split">/</div>
          {{ title.ins_name }}
        </div>
      </div>
    </div>
    <div class="org_content">
      <div class="org_content_org">
        <div
          class="org_content_org_item"
          v-for="item in contentList"
          :key="item.id"
        >
          <div
            class="org_content_org_item_left"
            :title="
              item.ins_name +
              (item.children ? '(' + item.children.length + ')' : '')
            "
          >
            {{ item.ins_name
            }}{{ item.children ? '(' + item.children.length + ')' : '' }}
          </div>
          <div @click="handleOrgClick(item)" class="org_content_org_icon">
            <!-- <div class="org_right_icon"></div> -->
            <span class="icon iconfont2">&#xe66e;</span>
            <div>下级</div>
          </div>
        </div>
      </div>
      <div class="org_content_user">
        <div v-loading="loading">
          <div
            v-if="contentList?.length == 0 || !contentList"
            class="ul_item"
            style="margin-top: 12px"
          >
            <div class="ul_item_name" @click.prevent="checkAll">
              <!-- <el-checkbox :value="allCheck"></el-checkbox> -->
              <div
                :class="[
                  'item-checkbox',
                  allCheck ? 'item-checkbox_ischecked' : 'item-checkbox',
                ]"
                style="margin-right: 8px"
              ></div>
              <span class="ul_item_realname"> 全选</span>
            </div>
          </div>
          <template v-if="orgUserList.length">
            <div
              class="org_content_user_item"
              v-for="item in orgUserList"
              :key="item.id"
              @click="handleUserClick(item)"
            >
              <div
                :class="[
                  'item-checkbox',
                  item.checked ? 'item-checkbox_ischecked' : 'item-checkbox',
                ]"
                style="margin-right: 8px"
              ></div>
              <div
                class="org_content_user_item_name"
                :title="
                  item.accountName +
                  '(' +
                  item.name +
                  ')-' +
                  item.organizationName
                "
              >
                {{ item.accountName }}({{ item.name }})-{{
                  item.organizationName
                }}
              </div>
            </div>
            <div
              v-if="orgUserList.length"
              style="color: #ccc; text-align: center; margin-top: 18px"
            >
              ↑已加载{{ this.totalCount > 50 ? 50 : this.totalCount }}条,共{{
                this.totalCount
              }}条数据↑<br />
              更多数据可搜索查询
            </div>
          </template>
          <template v-else>
            <div class="noMember" v-if="curOrg.id !== 'qb'">
              该机构下暂无可选人员
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getOrganizationMember } from '@/components/api/userOrgApi.js'
import { getPersonnelSelectionList } from '@/components/api/userOrgApi.js'

import alertUtils from '@/util/alertUtils.js'
export default {
  name: 'org-temp',
  props: ['orgList', 'widget'],
  data() {
    return {
      contentList: this.orgList, // 列表展示
      titleList: [{ ins_name: '全部', id: 'qb' }], // 表头标题
      curOrg: { ins_name: '全部', id: 'qb' }, // 当前选中机构
      loading: false,
      orgUserList: [], // 勾选的人员列表
      totalCount: 0,
      allCheck: false,
    }
  },
  created() {},
  computed: {},
  methods: {
    checkAll() {
      const allCheck = this.allCheck
      this.orgUserList.map(item => {
        this.$set(item, 'checked', allCheck)
        this.handleUserClick(item)
      })
      this.allCheck = !allCheck
    },
    // 更新展示列表
    handleOrgClick(org) {
      if (this.loading) {
        alertUtils.alertWarning('正在加载数据，请稍后', true)
        return
      }
      this.contentList = org.children
      this.curOrg = org
      this.titleList.push(org)

      this.getOrgUserList(org)
      this.$emit('sendCurOrgId', this.curOrg.id)
    },
    handleTitleClick(title, index) {
      if (title.id === this.curOrg.id) {
        return
      }
      if (title.id === 'qb' && title.ins_name === '全部') {
        const len = this.titleList.length
        this.contentList = this.orgList
        this.orgUserList = []

        this.curOrg = this.titleList[0]
        this.titleList.splice(index + 1, len - index - 1)
      }
      if (title.id !== 'qb') {
        const org = title
        const len = this.titleList.length
        this.curOrg = org
        this.contentList = org.children

        this.titleList.splice(index + 1, len - index - 1)
        this.getOrgUserList(org)
      }
      this.$emit('sendCurOrgId', this.curOrg.id)
    },
    handleUserClick(item) {
      this.$emit('change', item)
      if (this.orgUserList.every(oItem => oItem.checked)) {
        this.allCheck = true
      } else {
        this.allCheck = false
      }
    },
    // 获取组织机构下人员
    async getOrgUserList(curOrg) {
      if (this.loading) return
      this.allCheck = false
      const params = {
        orgId: curOrg.id,
        pageIndex: '0',
        pageSize: '50',
        identityTypeIds: this.widget.options.identityTypeIds,
      }
      if (this.widget.options.groupId) {
        params.type = 'group'
        params.groupId = this.widget.options.groupId
      }
      if (this.widget.options.useOraganization) {
        params.type = 'org'
      }
      if (this.widget.options.groupId && this.widget.options.useOraganization) {
        params.type = 'orgAndGroup'
        params.groupId = this.widget.options.groupId
      }
      this.loading = true
      try {
        const res = await getPersonnelSelectionList(params)
        if (res.flag) {
          this.totalCount = res.count
          if (!res.data.length) {
            this.loading = false
            this.orgUserList = []
            return
          }
          this.orgUserList = res.data.map(function (item) {
            item.checked = false
            return item
          })
          // 每次获取到的user，根据已选列表刷新选中状态
          this.orgUserList = this.$parent.$parent.refreshListChecked(
            this.$parent.$parent.selectedList,
            // eslint-disable-next-line prettier/prettier
            this.orgUserList,
          )
        }
        this.loading = false
      } catch (error) {
        this.loading = false
        alertUtils.alertError(error, true)
      }
    },
    // async getOrgUserList(curOrg) {
    //   console.log(111, 'orgList')
    //   console.log(this.widget, 'widget')
    //   if (this.loading) return
    //   this.allCheck = false
    //   const params = {
    //     organizationId: curOrg.id,
    //     pageIndex: '0',
    //     pageSize: '50',
    //   }
    //   this.loading = true
    //   try {
    //     const res = await getOrganizationMember(params)
    //     if (res.flag) {
    //       this.totalCount = res.count
    //       if (!res.data.length) {
    //         this.loading = false
    //         this.orgUserList = []
    //         return
    //       }
    //       this.orgUserList = res.data.map(function (item) {
    //         item.checked = false
    //         return item
    //       })
    //       // 每次获取到的user，根据已选列表刷新选中状态
    //       this.orgUserList = this.$parent.$parent.refreshListChecked(
    //         this.$parent.$parent.selectedList,
    //         // eslint-disable-next-line prettier/prettier
    //         this.orgUserList,
    //       )
    //     }
    //     this.loading = false
    //   } catch (error) {
    //     this.loading = false
    //     alertUtils.alertError(error, true)
    //   }
    // },
  },
  watch: {
    orgList: {
      handler(val) {
        this.contentList = val
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
div::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.org {
  width: 100%;
}
.org-head_root {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-family:
    PingFangSC-Medium,
    PingFang SC;
  font-weight: 500;
  color: #021525;
  line-height: 22px;
}
.org_root_icon {
  margin-right: 8px;
  width: 22px;
  height: 22px;
  background: url('~@/assets/zuzhiguanli.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.org-head_title {
  display: flex;
  align-items: center;
  padding: 0 30px;
  background: #fff;
  overflow-x: auto;
  flex-wrap: nowrap;
  margin-top: 6px;
}
.org_title {
  display: flex;
  font-size: 12px;
  font-family:
    PingFangSC-Regular,
    PingFang SC;
  font-weight: 400;
  color: #021525;
  line-height: 20px;
  white-space: nowrap;
  cursor: pointer;
}
.org_title_checked {
  color: #001526;
  opacity: 0.45;
  cursor: unset;
}
.org_title_split {
  margin: 0 10px;
  color: #ccc;
}

.org_content_org_item {
  width: 100%;
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.org_content_org_item_left {
  flex: 1;
  font-size: 14px;
  font-family:
    PingFangSC-Regular,
    PingFang SC;
  font-weight: 400;
  color: rgba(2, 21, 37, 0.85);
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.org_content_org_icon {
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 12px;
  font-family:
    PingFangSC-Regular,
    PingFang SC;
  font-weight: 400;
  color: rgba(2, 21, 37, 0.45);
  line-height: 12px;
}
.org_right_icon {
  margin-right: 4px;
  width: 12px;
  height: 12px;
  background: url('~@/assets/nextLevel.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.org_content_user_item {
  cursor: pointer;
  margin-top: 12px;
  display: flex;
  align-items: center;
}
.item-checkbox {
  border-radius: 2px;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  border: 1px solid #dcdfe6;
  transition: all 0.15s ease-in 0.05s;
}
.item-checkbox_ischecked {
  position: relative;
  background-color: #409eff;
  border-color: #409eff;
  box-sizing: border-box;
  &::after {
    box-sizing: content-box;
    content: '';
    border: 1px solid #fff;
    border-left: 0 !important;
    border-top: 0 !important;
    height: 7px;
    left: 4px;
    position: absolute;
    top: 1px;
    width: 3px;
    transition: all 0.15s ease-in 0.05s;
    transform-origin: center;
    transform: rotate(45deg) scaleY(1);
  }
}
.org_content_user_item_name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.noMember {
  color: rgba(2, 21, 37, 0.45);
  font-size: 12px;
}
.ul_item_name {
  cursor: pointer;
  display: flex;
  align-items: center;
}
</style>
